<template>
  <div
    class="kk-design__color"
    :style="{ backgroundColor: color }"
    :data-test-id="`color-item-${color?.replace('#', '')}`"
    @click="selectColor"
  ></div>
</template>
<script>
export default {
  props: ["color"],
  emits: ["select-color"],
  methods: {
    selectColor() {
      this.$emit("select-color", this.color);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";

.kk-design {
  &__color {
    cursor: pointer;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    border: 0.5px solid gray;
    &:hover {
      border: 1px solid black;
    }
  }
}
</style>
